import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

const selectWidgetStore = (state: ApplicationState) => state.WidgetStore

export const selectIsCreatingWidget = createSelector(
  [selectWidgetStore],
  (store) => store.isCreating
)

export const selectIsCreatingKpiOption = createSelector(
  [selectWidgetStore],
  (store) => store.isCreatingKpiOption
)

/**
 * Select fetch error for a specific widget
 * @param state - Application state
 * @param widgetId - Widget ID
 * @returns undefined (no error) or error object with status_code
 */
export const selectWidgetFetchError = createSelector(
  [
    (state: ApplicationState) => state.WidgetStore.fetchErrors,
    (state: ApplicationState, widgetId: string) => widgetId
  ],
  (fetchErrors, widgetId) => {
    return fetchErrors[widgetId]
  }
)
